import { render, staticRenderFns } from "./FrameList.vue?vue&type=template&id=1723f3bc&"
import script from "./FrameList.vue?vue&type=script&lang=ts&"
export * from "./FrameList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports